import { useEffect, useState } from 'react'

/**
 * Determines whether or not this is a server-side request.
 */
const useIsSSR = (): boolean => {
  const [SSR, setSSR] = useState<boolean>(true)

  useEffect(() => {
    setSSR(false)
  }, [])

  return SSR
}

export default useIsSSR
